import $ from "../../global/util";

export default {
  GET_CATEGORY_DETAILS: {
    PATH: "/categories",
  },
};
